import React, { Component } from 'react'
import PropTypes from 'prop-types'

class SocialIcon extends Component {
  render() {
    const { url, icon } = this.props

    return (
      <a href={ url } target="_blank" rel="noopener noreferrer">
        <img src={ icon } alt="instagram-icon"/>
      </a>
    );
  }
}

SocialIcon.propTypes = {
  url: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired
}

export default SocialIcon;



// WEBPACK FOOTER //
// ./src/components/social/icon/index.js